<template>
  <v-card tile elevation="0">
    <v-card-title>
      サービス実装
      <v-spacer></v-spacer>
      <v-switch
          v-if="editable"
          class="mt-0"
          v-model="serviceImplementation.publishing"
          label="公開"
          :readonly="!editable"
          @change="markDirty()"
          hide-details>
      </v-switch>
      <v-chip
          v-else
          color="primary"
          label>
        {{ serviceImplementation.publishing ? '公開' : '非公開' }}
      </v-chip>
    </v-card-title>
    <v-card-text>
      <slot name="before-service-implementation-info"></slot>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
              v-if="editable"
              v-model="serviceImplementation.localId"
              label="内部ID"
              :hint="serviceImplementation.id"
              :rules="[v => !!v || '内部IDが必要です']"
              @input="markDirty()"
              persistent-hint>
          </v-text-field>
          <local-id-field
              v-else
              :value="serviceImplementation.localId"
              :value-id="serviceImplementation.id"
              label="内部ID"
              hide-details>
          </local-id-field>
        </v-col>
        <v-col cols="5">
          <text-field-like
              :value="controller.name"
              :placeholder="serviceImplementation.controllerId"
              label="コントローラ名"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
              v-if="editable"
              v-model="serviceImplementation.remarks"
              label="備考"
              messages="複数行入力可"
              placeholder="未入力"
              persistent-placeholder
              rows="1"
              @input="markDirty()"
              auto-grow>
          </v-textarea>
          <text-field-like
              v-else
              v-model="serviceImplementation.remarks"
              label="備考"
              placeholder="未入力"
              multi-line
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>

      <v-card class="pa-3 mt-3 elevation-1" outlined>
        <v-row dense>
          <v-col md="3" cols="8">
            <text-field-like
                label="個別辞書名"
                :value="localServiceComponentModel.dictionary.name"
                :value-hds-id="localServiceComponentModel.dictionary.id"
                hide-details>
              <template #default="{value}">
                <deletable-field :value="value" :deleted="localServiceComponentModel.dictionary.isDeleted"/>
              </template>
            </text-field-like>
          </v-col>
          <v-col md="3" cols="8">
            <text-field-like
                :value="localServiceComponentModel.name"
                :value-hds-id="localServiceComponentModel.id"
                label="サービス構成モデル名"
                hide-details>
            </text-field-like>
          </v-col>
          <v-col md="6" cols="12">
            <text-field-like
                :value="localServiceComponentModel.description"
                label="説明"
                placeholder="未設定"
                hide-details
                multi-line>
            </text-field-like>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import DeletableField from "@/components/molecules/DeletableField.vue";
import gql from "graphql-tag";
import LocalIdField from "@/components/molecules/LocalIdField.vue";

export default {
  name: 'ServiceImplementationInfo',
  components: {LocalIdField, DeletableField, TextFieldLike},
  props: {
    serviceImplementation: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      localServiceComponentModel: {
        dictionary: {}
      },
      controller: {}
    };
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    markDirty() {
      this.$emit('dirty');
    },
  },
  watch: {
    'serviceImplementation.controllerId': {
      immediate: true,
      async handler(controllerId) {
        if(!controllerId) {
          return;
        }

        const {data: controller} = await this.hcsClient.get(`/controllers/${controllerId}`);
        this.controller = controller;
      }
    },
    'serviceImplementation.serviceComponentModelId': {
      immediate: true,
      async handler(serviceComponentModelId) {
        if(!serviceComponentModelId) {
          return;
        }

        const {localServiceComponentModel} = await this.gqlQuery({
          query: gql`
              query FindServiceComponentModel(
                  $localServiceComponentModelId: ID!,
              ) {
                  localServiceComponentModel: serviceComponentModel(serviceComponentModelId: $localServiceComponentModelId) {
                      id
                      name
                      description
                      dictionary {
                        id
                        name
                        description
                        isDeleted
                      }
                  }
              }`,
          variables: {
            localServiceComponentModelId: serviceComponentModelId
          }
        });
        this.localServiceComponentModel = localServiceComponentModel;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input.v-input--switch .v-label {
  white-space: nowrap;
}
</style>
